<div class=" mt-">
  <section class="my-4">
    <div class="scrollmenu"> 
      <a   [routerLink]="['/PayOut/NewPayOutContact']">New Payout Contact</a> 
      <a class="active menu"  [routerLink]="['/PayOut/PayoutAccountdetails']">PayOut Security</a>
      
    </div>
  </section> 
 <section class="mt-3"  >
    <div class="">
      <div class="row">
        <div class="col-md-12 pb-5">
          <div class="float-right">
            <button class="dash-btns mr-3" [routerLink]="['/PayOut/managePayoutAccountdetails']">Manage Payout Security </button>
    
            <button [routerLink]="['/reports/transactions/summary']" class="dash-btns ">Reports</button>
    
    
          </div>
        </div>
        <div class="col-md-7"  *ngIf="AddSecurity">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <!-- <img src="assets/img/new/view-trans.svg" /> -->

                  <h4><b>Payout Security</b></h4>
                </div>



                <div>
                  <!-- <h5><b>Bank Account Details</b></h5> -->

                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Customer AccountId<span class="text-danger"></span></label>
                      <select class="formcontrol-user1 form-control" [(ngModel)]="PayoutAccountkeyid" placeholder="Customer AccountId" [formControl]="PayoutAccountid" required>
                        <option [ngValue]="null" [disabled]="false" >Select Payout Customer AccountId</option>
                        <option value="" disabled selected hidden>Please
                            Select Payout Customer AccountId</option>
                        <option [value]="PayoutAccountkeyid" disabled selected hidden>{{PayoutAccountkeyid}}</option>
                        <option *ngFor="let item of ContactList">
                            {{item.CustomerAccountId}}- {{item.FirstName}}

                        </option>

                  </select>
                      </div>
                     
                    </div>
                  </div>




                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">New Bank Account Number<span class="text-danger">*</span></label>
                        <input type="password" class="formcontrol-user1 form-control"
                          placeholder="New Bank Account Number" maxlength="18" minlength="9" id="bAccountNumber" (keypress)="numberOnly($event)"
                          name="bAccountNumber" aria-label="bAccountNumber" onCopy="return false" onDrag="return false"
                          onDrop="return false" onPaste="return false"
                          [formControl]="bAccountNumber" (change)=onChange()  (change)=CheckAccNumAndIfsccode()
                         required>
                         <!-- (change)=CheckAccNumAndIfsccode() -->
                      </div>
                      
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Confirm New Bank Account Number<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control"
                          placeholder="Confirm New Bank Account Number" id="bConfirmAccountNumber"
                          name="bConfirmAccountNumber" aria-label="bConfirmAccountNumber" onCopy="return false"
                          onDrag="return false" onDrop="return false"  onPaste="return false"
                          [formControl]="bConfirmAccountNumber" required (change)=onChange() maxlength="18"
                          minlength="9" (keypress)="numberOnly($event)">
                      </div>
                      
                    </div>
                    <small style="color:red;" *ngIf="!isConfirmNumberSameAsAccountnumber">Confirm Account Number should
                      match with Account Number!</small>
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">IFSC Code/Bank Code<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="IFSC Code/Bank Code"
                          id="bBankCode" name="bBankCode" aria-label="bBankCode" [formControl]="bBankCode"
                          maxlength="11" minlength="9" required (change)=CheckAccNumAndIfsccode()>
                          <!-- (change)=CheckAccNumAndIfsccode() -->
                      </div>
                     
                      <!-- <span class="text-danger" *ngIf="requestAccIfsccode">Account Number and Ifsc code already Exist</span> -->
                      <!-- <span *ngIf="ifsccodedetails" class="text-danger">Details not found 
                      </span> -->
                    </div>
                    <!-- <div  class="text-right col-12">  
                      <button class="btn dash-btns" id="Savecoupon" color="primary"
                      (click)="GetIfsccodedetails()" [disabled]="bBankCode.invalid">
                      Validate IFSCcode</button>
                    </div> -->
                  </div>
                  <div class="row pt-2">

                    <div class="col-md-12">
                     
                      <div class="form-group formgroup-tm">
                        <label class="customlabel ">Document / proof</label>
                        <div class="formcontrol-user1 form-control">
                          <input type="file" 
                          matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                          id="Documentimage" multiple (change)="getFileDetails($event,9)">
                        </div>
                       
                      </div>
                      <small *ngIf="invalidfile"class="text-danger">Supported File Types Are: *Jpeg/ *jpg/ *png/ *pdf</small>
                    </div>
                  </div>
                  <!-- <div class="row pt-2">

                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Bank Name<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="Bank Name" id="bBankName"
                          name="bBankName" aria-label="bBankName" [formControl]="bBankName" [(ngModel)]="IfscBankName" required>
                      </div>
                      <span class="text-danger"
                        *ngIf="bBankName.invalid && (bBankName.dirty || bBankName.touched)">{{bBankNameerrors()}}
                      </span>
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Branch Name<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="Branch Name"
                          id="BranchName" name="BranchName" aria-label="BranchName" [formControl]="BranchName" required   [(ngModel)]="IfscBranchName">
                      </div>
                      <span class="text-danger"
                        *ngIf="BranchName.invalid && (BranchName.dirty || BranchName.touched)">{{BranchNameerrors()}}
                      </span>
                    </div>
                  </div>


                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Beneficiary Name<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="Beneficiary Name"   id="BeneficiaryName" name="BeneficiaryName" aria-label="BeneficiaryName"
                          [formControl]="BeneficiaryName" required>
                      </div>
                      <span class="text-danger"
                        *ngIf="BeneficiaryName.invalid && (BeneficiaryName.dirty || BeneficiaryName.touched)">{{BeneficiaryNameerrors()}}
                      </span>
                    </div>
                  </div>


               
                  <div class="row pt-2">

                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel"> Bank Account Type <span class="text-danger">*</span></label>
                        <div class="selectcustom">
                          <ngx-select [items]="AccountType" id="bBankAccountType" placeholder="BankAccount Type" name="bBankAccountType" [formControl]="bBankAccountType" required></ngx-select>
                        </div>
                      

                      </div>
                      <span class="text-danger"
                        *ngIf="bBankAccountType.invalid && (bBankAccountType.dirty || bBankAccountType.touched)">{{BankAccountTypeerrors()}}</span>

                    </div>
                  </div> -->

                  <div class="form-group  clear formgroup-tmmb-0">
                    <div class=" "  *ngIf="uaturl">
                      <input   type="checkbox" id="policycheckbox"  name="policycheckbox" [checked]='true'  (change)="click()">  
                      <label class=" ml-2" for="customCheck"><a href="https://fastswiff.com/privacy-policy.html" class="font-16 blue-t" target="_blank">Privacy Policy and Terms</a> </label>
                      
                    </div>
                    <div class=" "  *ngIf="produrl">
                      <input  class=" " type="checkbox" id="policycheckbox"  name="policycheckbox" [checked]='true'  (change)="click()">  
                      <label class=" ml-2 " for="customCheck"> <a href="https://fastswiff.com/privacy-policy.html" target="_blank" class="font-16 blue-t">Privacy Policy and Terms</a></label>
                      
                    </div>
                    <small>By Registering, you agree to our privacy policy and terms of use.</small>
                  <p>
                    <small  class="text-danger" style="    font-size: x-small;" *ngIf="ispolicy">Please Accept privacy policy and terms of use</small> 

                  </p>  
                  </div>
                  <div class="pt-2">
                    <button type="button" color="primary" class="dash-btns btn"  id="btngotobankEdit"
                      [disabled]="bAccountNumber.invalid ||bBankCode.invalid||bConfirmAccountNumber.invalid||!isConfirmNumberSameAsAccountnumber||ispolicy||Bankdetailserrormessage||Securitybtn||invalidfile "
                      (click)="SaveBankAccountDetails()">Submit </button>
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="EditSecurity">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <!-- <img src="assets/img/new/view-trans.svg" /> -->

                  <h4><b>Edit Payout Security</b></h4>
                </div> 

                <div>
                  <!-- <h5><b>Bank Account Details</b></h5> -->

                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm" *ngIf="EdicustomerAccId">
                        <label class="customlabel">Customer AccountId<span class="text-danger"></span></label>
                      <select class="formcontrol-user1 form-control" placeholder="Customer AccountId" [formControl]="PayoutAccountid" [(ngModel)]="PayoutCustomerAccountId" required>
                      <option value="" disabled selected hidden>Please
                        Select Payout Customer AccountId</option>
                          <option [value]="PayoutCustomerAccountId" disabled selected hidden> {{PayoutCustomerAccountId}}</option>
                      <option *ngFor="let item of ContactList">
                          {{item.CustomerAccountId}}- {{item.FirstName}}

                      </option>
                  </select>
                
                      </div>

                      <div class="form-group formgroup-tm" *ngIf="nonEdicustomerAccId">
                        <label class="customlabel">Customer AccountId<span class="text-danger"></span></label>
                      <select class="formcontrol-user1 form-control" placeholder="Customer AccountId" [formControl]="PayoutAccountid" [(ngModel)]="PayoutCustomerAccountId" required readonly>
                      <option value="" disabled selected hidden>Please
                          Select Payout Customerkey Id</option>
                          <option [value]="PayoutCustomerAccountId" disabled selected hidden> {{PayoutCustomerAccountId}}</option>
                      <option *ngFor="let item of ContactList" >
                          {{item.CustomerAccountId}}- {{item.FirstName}}

                      </option>
                  </select>
                
                      </div>
                     
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">New Bank Account Number<span class="text-danger">*</span></label>
                        <input type="password" class="formcontrol-user1 form-control"
                          placeholder="New Bank Account Number" maxlength="18" minlength="9" id="bAccountNumber"
                          name="bAccountNumber" aria-label="bAccountNumber" onCopy="return false" onDrag="return false"
                          onDrop="return false" onPaste="return false"
                          [formControl]="bAccountNumber" (change)=onChange() [(ngModel)]="BankAccnum"   (change)=CheckAccNumAndIfsccode()
                         required>
                         <!-- (change)=CheckAccNumAndIfsccode() -->
                      </div>
                     
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Confirm New Bank Account Number<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control"
                          placeholder="Confirm New Bank Account Number" id="bConfirmAccountNumber"
                          name="bConfirmAccountNumber" aria-label="bConfirmAccountNumber" onCopy="return false"
                          onDrag="return false" onDrop="return false"  onPaste="return false"
                          [formControl]="bConfirmAccountNumber" required (change)=onChange() maxlength="18"
                          minlength="9" [(ngModel)]="ConfirmBankAccnum">
                      </div>
                     
                    </div>
                   
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">IFSC Code/Bank Code<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="IFSC Code/Bank Code"
                          id="bBankCode" name="bBankCode" aria-label="bBankCode" [formControl]="bBankCode"
                          maxlength="11" minlength="9" required [(ngModel)]="BankIfsccode"  (change)=CheckAccNumAndIfsccode()>
                          <!-- (change)=CheckAccNumAndIfsccode() -->
                      </div>
                   
                      <!-- <span class="text-danger" *ngIf="requestAccIfsccode">Account Number and Ifsc code already Exist</span> -->
                      <!-- <span *ngIf="ifsccodedetails" class="text-danger">Details not found 
                      </span> -->
                    </div>
                    <!-- <div  class="text-right col-12">  
                      <button class="btn dash-btns" id="Savecoupon" color="primary"
                      (click)="GetIfsccodedetails()" [disabled]="bBankCode.invalid">
                      Validate IFSCcode</button>
                    </div> -->
                  </div>
                  <div class="row pt-2">

                    <div class="col-md-12">
                     
                      <div class="form-group  formgroup-tm">
                        <label class="customlabel ">Document / proof</label>
                        <div class="formcontrol-user1 form-control">
                          <input type="file" class="" matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                          id="Documentimage" multiple (change)="getFileDetails($event,9)">
                        </div>
                     
                      </div>

                    </div>
                  </div>
                  <!-- <div class="row pt-2">

                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Bank Name<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="Bank Name" id="bBankName"
                          name="bBankName" aria-label="bBankName" [formControl]="bBankName" [(ngModel)]="IfscBankName" required>
                      </div>
                      <span class="text-danger"
                        *ngIf="bBankName.invalid && (bBankName.dirty || bBankName.touched)">{{bBankNameerrors()}}
                      </span>
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Branch Name<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="Branch Name"
                          id="BranchName" name="BranchName" aria-label="BranchName" [formControl]="BranchName" required   [(ngModel)]="IfscBranchName">
                      </div>
                      <span class="text-danger"
                        *ngIf="BranchName.invalid && (BranchName.dirty || BranchName.touched)">{{BranchNameerrors()}}
                      </span>
                    </div>
                  </div>


                  <div class="row pt-2">
                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel">Beneficiary Name<span class="text-danger">*</span></label>
                        <input type="text" class="formcontrol-user1 form-control" placeholder="Beneficiary Name"   id="BeneficiaryName" name="BeneficiaryName" aria-label="BeneficiaryName"
                          [formControl]="BeneficiaryName" required>
                      </div>
                      <span class="text-danger"
                        *ngIf="BeneficiaryName.invalid && (BeneficiaryName.dirty || BeneficiaryName.touched)">{{BeneficiaryNameerrors()}}
                      </span>
                    </div>
                  </div>


               
                  <div class="row pt-2">

                    <div class="col-md-12"> 
                      <div class="form-group formgroup-tm">
                        <label class="customlabel"> Bank Account Type <span class="text-danger">*</span></label>
                        <div class="selectcustom">
                          <ngx-select [items]="AccountType" id="bBankAccountType" placeholder="BankAccount Type" name="bBankAccountType" [formControl]="bBankAccountType" required></ngx-select>
                        </div>
                      

                      </div>
                      <span class="text-danger"
                        *ngIf="bBankAccountType.invalid && (bBankAccountType.dirty || bBankAccountType.touched)">{{BankAccountTypeerrors()}}</span>

                    </div>
                  </div> -->

                  <div class="form-group  clear formgroup-tmmb-0">
                    <div class=" "  *ngIf="uaturl">
                      <input   type="checkbox" id="policycheckbox"  name="policycheckbox" [checked]='true'  (change)="click()">  
                      <label class=" ml-2" for="customCheck"><a href="" class="font-16 blue-t" target="_blank">Privacy Policy and Terms</a> </label>
                      
                    </div>
                    <div class=" "  *ngIf="produrl">
                      <input  class=" " type="checkbox" id="policycheckbox"  name="policycheckbox" [checked]='true'  (change)="click()">  
                      <label class=" ml-2 " for="customCheck"> <a href="" target="_blank" class="font-16 blue-t">Privacy Policy and Terms</a></label>
                      
                    </div>
                    <small>By Registering, you agree to our privacy policy and terms of use.</small>
                  <p>
                    <small  class="text-danger" style="    font-size: x-small;" *ngIf="ispolicy">Please Accept privacy policy and terms of use</small> 

                  </p>  
                  </div>
                  <div class="pt-2">
                    <button type="button" color="primary" class="dash-btns btn" id="btngotobankEdit"
                      [disabled]="bAccountNumber.invalid ||bBankCode.invalid||bConfirmAccountNumber.invalid||!isConfirmNumberSameAsAccountnumber||ispolicy"
                      (click)="SaveBankAccountDetails()">Submit </button>
                  </div>

                </div>


              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="card-1 p-2">
            <div class="text-center">
                <!-- <img src="assets/img/new/invoices.gif" /> -->
                <div *ngIf="!isimgHidden">
                  <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
                </div>
            </div>
            <div class=""  *ngIf="AddSecurity">
              <span *ngIf="requiredAccountiderror"></span>
                      <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
              
              *ngIf="Bankdetailserrormessage">Beneficiary already exists for this account number</div>
                      <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                *ngIf="bAccountNumber.invalid && (bAccountNumber.dirty || bAccountNumber.touched)">{{bAccountNumbererrors()}}
              </div>
                      <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                *ngIf="bConfirmAccountNumber.invalid && (bConfirmAccountNumber.dirty || bConfirmAccountNumber.touched)">{{bconfirmAccountNumbererrors()}}
              </div>
                      <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                *ngIf="bBankCode.invalid && (bBankCode.dirty || bBankCode.touched)">{{bBankCodeerrors()}}
              </div>
            </div>
            <div class=""  *ngIf="EditSecurity">
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="!isConfirmNumberSameAsAccountnumber">Confirm Account Number should
                match with Account Number!</div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="requiredAccountiderror"></div>
              <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" *ngIf="requiredAccountiderror"></div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" class="text-danger" *ngIf="Bankdetailserrormessage">Details already exists for this account number</div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" class="text-danger" *ngIf="bAccountNumber.invalid && (bAccountNumber.dirty || bAccountNumber.touched)">{{bAccountNumbererrors()}}  </div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" class="text-danger" *ngIf="bConfirmAccountNumber.invalid && (bConfirmAccountNumber.dirty || bConfirmAccountNumber.touched)">{{bconfirmAccountNumbererrors()}}
                </div>
               <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" class="text-danger"   *ngIf="bBankCode.invalid && (bBankCode.dirty || bBankCode.touched)">{{bBankCodeerrors()}}   </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="" >
      <div class="row">
      
      </div>
    </div>
  </section>

</div>